module.exports = __webpack_public_path__ + "static/img/browser-icon.1e3e444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/browser-icon.png
// module id = Ndie
// module chunks = 5